
import CargoCategory from '../loads/filters/CargoCategory.vue';
import EquipmentTypeCategory from '../loads/filters/EquipmentTypeCategory.vue';
import PickupDelivery from '../loads/filters/PickupDelivery.vue';

export default {
  components: { PickupDelivery, CargoCategory, EquipmentTypeCategory },
  data() {
    return {
      reset: false,
      filters: {
        pickup: {
          suburb: null
        },
        delivery: {
          suburb: null
        },
        state: null,
        cargoCategory: null,
        equipmentType: null
      }
    };
  },
  watch: {
    filters : {
      handler() {
        this.$emit('filter-changed', this.filters)
      },
      deep: true,
      immediate: true
    },
    reset(){
      this.$emit('search')
    }
  },
  methods: {
    pickupChanged (value) {
      this.filters.pickup = value
    },
    deliveryChanged (value) {
      this.filters.delivery = value
    },
    stateChanged (value) {
      this.filters.state = value
    },
    cargoCategoryChanged (value) {
      this.filters.cargoCategory = value
    },
    equipmentTypeChanged (value) {
      this.filters.equipmentType = value
    },
    searchTruck () {
      this.$emit('search')
    },
    resetFilters () {
      this.reset = !this.reset
      this.filters ={
        pickup: {
          suburb: null
        },
        delivery: {
          suburb: null
        },
        state: null,
        cargoCategory: null,
        equipmentType: null
      }
    }
  }
}
